import { fetchAuthSession } from 'aws-amplify/auth';

import type { AuthHeader } from '../interfaces';

/**
 * Bearer JWT headers for admin routes behind the JWT API Gateway authorizer.
 * Cognito IAM signing (default Amplify REST) is rejected on these paths.
 */
const getAdminJwtAuthHeaders = async (): Promise<Partial<AuthHeader>> => {
    try {
        const { tokens } = await fetchAuthSession();
        const idToken = tokens?.idToken;
        const sub = idToken?.payload?.sub;
        const jwt = idToken?.toString();
        if (sub && jwt) {
            return {
                Authorization: `Bearer ${jwt}`,
                SpecterxUserId: sub as string,
            };
        }
    } catch {
        // No session — caller will get a 401 from the API.
    }
    return {};
};

export default getAdminJwtAuthHeaders;
